'use strict';
angular.module('schoolLinqApp').factory('bankService', [
	'$http',
	function ($http) {
		var endpoint = '/api/banks';

		function getBank(id, overrideAccess) {
			return $http.get(endpoint + '/' + id, {
				params: { overrideAccess: overrideAccess },
			});
		}

		function getBankBookBalance(id, endingDate) {
			return $http.get(endpoint + '/' + id + '/book-balance', {
				params: { endingDate: endingDate },
			});
		}

		function getImages(id) {
			return $http.get(endpoint + '/' + id + '/images');
		}

		function removeImage(id, location) {
			return $http.post(endpoint + '/remove-image', {
				Id: id,
				Location: location,
			});
		}

		function getBanks(cashOnly, activeOnly) {
			return $http.get(endpoint, {
				params: { cashOnly: cashOnly, activeOnly: activeOnly },
			});
		}

		function addBank(bank) {
			return $http.post(endpoint, bank);
		}

		function saveBank(bank) {
			return $http.put(endpoint, bank);
		}

		function deleteBank(id) {
			return $http.delete(endpoint + '/' + id);
		}

		function removedAttachedAccountOnBank(id, accountId) {
			return $http.delete(endpoint + '/' + id + '/accounts/' + accountId);
		}

		function addAttachedAccountOnBank(id, accountIds) {
			return $http.post(endpoint + '/' + id + '/accounts', {
				AccountIds: accountIds,
			});
		}

		function getPreviewCheckImage(id, productInitials) {
			return $http.get(endpoint + '/getpreviewcheck', {
				params: { Id: id, ProductInitials: productInitials },
			});
		}

		return {
			getBank: getBank,
			getBankBookBalance: getBankBookBalance,
			getBanks: getBanks,
			addBank: addBank,
			saveBank: saveBank,
			getImages: getImages,
			removeImage: removeImage,
			deleteBank: deleteBank,
			removedAttachedAccountOnBank: removedAttachedAccountOnBank,
			addAttachedAccountOnBank: addAttachedAccountOnBank,
			getPreviewCheckImage: getPreviewCheckImage,
		};
	},
]);
